import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { AppHttp, SessionSetting } from '../../app.service';
import { Router, ActivatedRoute } from '@angular/router';
import { ModalDirective } from 'ngx-bootstrap';

declare var $: any;

@Component({
  selector: 'app-change',
  templateUrl: './changepw.component.html',
  styleUrls: ['./changepw.component.css']
})

export class ChangePWComponent implements OnInit {

  user_id: string;
  @ViewChild('lgModal') public lgModal: ElementRef;
  @ViewChild('modal') public lg: ElementRef;

  validationOptions: any = {
    // Rules for form validation
    rules: {
      USER_PASSWORD_OLD: { required: true },
      USER_PASSWORD_NEW: { required: true, pwd: true, minlength: 8, maxlength: 32 },
      USER_PASSWORD_CONFIRM: { required: true, pwd: true, minlength: 8, maxlength: 32, equalTo: "[name=USER_PASSWORD_NEW]" }
    },
    submitHandler: () => this.changePassWord()
  };
  public constructor(
    private router: Router,
    private http: AppHttp,
    private activated: ActivatedRoute
  ) { }

  ngOnInit() {
  }

  show() {
    this.user_id = SessionSetting.getUser() == null ? '' : SessionSetting.getUser().UserID;
    $("[name='changPW']")[0].reset();
    $(this.lgModal.nativeElement).modal({ backdrop: 'static', keyboard: false });
  }

  changePassWord() {
    if (!$("form[name='changPW']").valid()) { return; }
    $('[name=changeOK]').prop('disabled', true);
    let param = {};
    $("form[name='changPW']").serializeArray().forEach(elem => {
      param[elem.name] = elem.value;
    });
    param["USER_ID"] = this.user_id;
    param['COMPANY_ID'] = 'DUMMY';
    this.http.put('main', '/main/password/changePassword', param).then(r => {
      $('[name=changeOK]').prop('disabled', false);
      if (r.success) {
        $(this.lgModal.nativeElement).modal('hide');
      }
    });
  }

  close() {
    $(this.lgModal.nativeElement).modal('hide');
    $('[name=changeOK]').prop('disabled', false);
    let validator = $("form[name='changPW']").validate();
    validator.resetForm();
    $("form[name='changPW']")[0].reset();
  }
}



// WEBPACK FOOTER //
// C:/wxj/LicAuth/05開発/LicAuth.angularjs/src/app/pf.main/changepw/changepw.component.ts